/* eslint-disable react/no-unused-prop-types */
import React, { FunctionComponent } from 'react';
import { makeStyles } from '@material-ui/core';
import { useProfileContext } from 'src/lib/profiles/ProfileContext';
import { MenuCollection } from '../../ui/menu';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { SideMenu, SidebarProvider } from '../SideMenu';

const useStyles = makeStyles(() => ({
  container: {
    overflowX: 'hidden',
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
  },
  mainContainer: {
    minHeight: 800,
    padding: '24px 0 0',
  },
}));

interface MainLayoutProps {
  children: React.ReactNode;
  menu: MenuCollection;
}

export const MainLayout: FunctionComponent<MainLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const { profile } = useProfileContext();
  const isPrivateProfile = profile === 'private';

  return (
    <SidebarProvider>
      <div className={classes.container}>
        <Header showMenuButton={isPrivateProfile} />
        {isPrivateProfile && <SideMenu />}
        <main className={classes.mainContainer}>
          {children}
          <Footer />
        </main>
      </div>
    </SidebarProvider>
  );
};
